var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTournament = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.554 3.979H16.604V9.345H9.548V20.41H16.605V23.877l.056.152 3.885 10.429.218.586h5.487v10.372h-8.158V50.596h-3.367V56.02h30.548v-5.426h-3.367v-5.179h-8.288V35.044h5.697l.21-.605 3.626-10.429.05-.142v-.15l.012-3.307h7.24V9.345h-7.202l.015-4.463.003-.903h-3.345v1.8h1.539l-.061 17.782-3.367 9.683H22.014l-3.61-9.692V5.78h12.15v-1.8Zm-12.46 48.417h-1.568v1.825h26.948v-1.825H18.093Zm22.013-5.18v3.38H19.893v-3.38H40.107Zm-8.288-1.8h-3.768V35.044h3.768v10.372ZM11.347 18.611v-7.466h5.192v7.466h-5.192Zm32.114-7.466v7.466h5.193v-7.466H43.46Z",
  fill: "#1FDAFF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.629 4h1.757v1.757h-1.757V4Z",
  fill: "#fff"
})));
export default SvgTournament;